/**
 * Password
 */
export const PasswordChange = (function () {

  var init =  function () {
    addEventListeners();     
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    // Onclick on the submit button
    $('.myds-password-change').each(function () {
      $(this).find('form').on('submit',function (event) {
          // Stop the form submitting
          event.preventDefault();
          event.stopPropagation();
          
          // Create a variable from this.  So that we can use it later on within the promise callback
          var form = this;

          // Validate the result and stop 
          if(!validate(form)){
            return;
          }
          
          // Change the password and display the result
          var promise = patchChangePassword( getInputs( form ) );
          promise.then(function () {
              Util.toggleAlert('.alert', "Success: Password Changed!", 'alert-success');
              resetForm(form);
          });
          promise.fail(function (response) {
              var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
              Util.toggleAlert('.alert', message , 'alert-warning');
          });          
      });
      // Shows the current strength level of the password 
      $(this).find('.check-strength').on('keyup', function () {
        checkStrength($('.check-strength').val())
      })  
    });

    // Shows the current strength level of the password 
    $('.check-strength').on('keyup', function () {
      checkStrength($(this).val())
    })

    // Toggles between showing and hiding password
    $(".show-hide-password a").on('click', function (event) {
      event.preventDefault();
      // If current password is being toggled only allow that input box to be shown
      if ($(this).hasClass("current-password")) {
        // toggleClass will swap these two classes if the other one is present, this is what adds the slash through the eye
        $('.eye-current').toggleClass('fa-eye-slash fa-eye');
        var $password = $('.current-password input')
        if ($password.attr('type') === 'password') {
          $password.attr('type', 'text');
        } else {
          $password.attr('type', 'password');
        }
      } else {
        // Toggles both new password and confirm password inputs as both have the new-confirm-password class
        $('.eye').toggleClass('fa-eye-slash fa-eye');
        var $newPassword = $('.new-confirm-password input')
        if ($newPassword.attr('type') === 'password') {
          $newPassword.attr('type', 'text');
        } else {
          $newPassword.attr('type', 'password');
        }
      }
    });
  }
  /**
   * HTTP FUNCTIONS
   */
  function patchChangePassword( data ) {
      
      var csrf = Util.getCSRF();
      return $.ajax({
        url: `/password/change`,
        type: 'patch',
        dataType: 'json',
        headers: {
          'x-csrf-token': csrf
        },
        data: data,
      });
  }
  /**
   * HELPER FUNCTIONS
   */
  /**
   * Validate the password reset form using the HTML Constraint API
   * @param {*} form 
   * @returns 
   */
  function validate( form ) {

    // Remove the was-validated class if it existed on the form.  This will clear the validatoin back to a blank slate
    $(form).removeClass('was-validated');

    // Get the data-id of the form - if not exist stop, we need the ID
    let id = form.getAttribute('data-id');
    if(!id) { throw Error(`No id supplied for password-change component ${id}`);}
    
    var newpassword = document.getElementById(`myds-password-change-newpassword-${id}`);
    var confirmpassword = document.getElementById(`myds-password-change-confirmpassword-${id}`);
    var currentpassword = document.getElementById(`myds-password-change-currentpassword-${id}`);
   
    // Check there are values and the min lengh is > 8
    // Not it should be possible to induvidually check constraints 
    var  isValid = true;
    if (form.checkValidity() === false) {
      document.getElementById(`myds-password-change-currentpasswordinfo-${id}`).innerHTML = "This field is required";
      document.getElementById(`myds-password-change-newpasswordinfo-${id}`).innerHTML = "This field is required and must be greater than 8 characters";
      document.getElementById(`myds-password-change-confirmpasswordinfo-${id}`).innerHTML = "This field is required and must be greater than 8 characters";
      isValid = false;
    }
    
    // Check the new/confirmation match
    if ( newpassword.value != confirmpassword.value ) {
      // Set the styling and message for the error
      newpassword.classList.add('is-invalid');
      confirmpassword.classList.add('is-invalid');
      document.getElementById(`myds-password-change-newpasswordinfo-${id}`).innerHTML = "Passwords Don't Match";
      document.getElementById(`myds-password-change-confirmpasswordinfo-${id}`).innerHTML = "Passwords Don't Match";
      isValid = false;
    }
    $(form).toggleClass('was-validated');
    return isValid;
  }

  function getInputs( form ) {
    // Get the data-id of the form
    var id = form.getAttribute('data-id')
    if(!id) { throw Error(`No id supplied for password-change component ${id}`);}
    
    // Get the values form the form
    var newpassword = document.getElementById(`myds-password-change-newpassword-${id}`).value;
    var currentpassword = document.getElementById(`myds-password-change-currentpassword-${id}`).value;
    var confirmpassword = document.getElementById(`myds-password-change-confirmpassword-${id}`).value;

    return {
      'current_password' : currentpassword,
      'new_password' : newpassword,
      'new_password_confirmation' : confirmpassword
    }
  }
  function resetForm( form ) {
    // Get the data-id of the form
    var id = form.getAttribute('data-id')
    if(!id) { throw Error(`No id supplied for password-change component ${id}`);}
    
    // Get the values form the form
    document.getElementById(`myds-password-change-newpassword-${id}`).value = "";
    document.getElementById(`myds-password-change-currentpassword-${id}`).value = "";
    document.getElementById(`myds-password-change-confirmpassword-${id}`).value = "";

    // Reset the strengh checker
    checkStrength($('.check-strength').val())

    $(form).removeClass('was-validated');
  }

  return {
    init: init
  }
}());
/**
 * Password Reset Module
 */
export const PasswordReset = (function () {

  var init =  function () {  
    addEventListeners();       
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    // Onclick on the submit button
    $('.myds-password-reset').find('form').on('submit',function () {
        // Stop the form submitting
        event.preventDefault();
        event.stopPropagation();

        // Create a variable from this.  So that we can use it later on within the promise callback
        var form = this;

        // Validate the result and stop 
        if(!validate(form)){
          return;
        }

        // Get the data-id of the form
        var id = form.getAttribute('data-id')
        if(!id) { throw Error(`No id supplied for password-reset component ${id}`);}
          
        // Get the values form the form

        var credential = document.getElementById(`myds-password-reset-credential-${id}`).value;
        
        // Change the password and display the result
        var promise = postResetPassword( {
          'credential' : credential
        } );
        promise.then(function () {
            Util.toggleAlert('.alert', "Success! Further instructions have been sent to your e-mail address.", 'alert-success', -1);
            // Reset the form
            document.getElementById(`myds-password-reset-credential-${id}`).value = "";
            $(form).removeClass('was-validated');
        });
        promise.fail(function (response) {
            var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
            Util.toggleAlert('.alert', message , 'alert-warning');
        });     
    });

    // Click Listeners for the password reset page when a member enters a new password
    $('.myds-password-change-reset').each(function () {
      $(this).find('form').on('submit',function () {
          // Stop the form submitting
          event.preventDefault();
          event.stopPropagation();

          // Create a variable from this.  So that we can use it later on within the promise callback
          var form = this;

          // Validate the result and stop 
          if(!validatePasswordChangeReset(form)){
            return;
          }

          // Get the data-id of the form
          var id = form.getAttribute('data-id')
          if(!id) { throw Error(`No id supplied for password-reset component ${id}`);}
          
          // Get the values form the form
          var newpassword = document.getElementById(`myds-password-change-reset-newpassword-${id}`);
          var confirmpassword = document.getElementById(`myds-password-change-reset-confirmpassword-${id}`);

          // Change the password and display the result
          var promise = postPasswordChangeReset({
            'new_password' : newpassword.value,
            'new_password_confirmation' : confirmpassword.value
          });
          promise.then(function () {
              Util.toggleAlert('.alert', "Success: Your password has been reset.  Click <a href='/'>Here</a> to login", 'alert-success', -1);
              $('.myds-password-change-reset-form').parent().fadeOut("normal").remove();
          });
          promise.fail(function (response) {
              var message = (response.responseJSON != undefined) ? response.responseJSON['message'] : 'There was an error while processing this request.';
              Util.toggleAlert('.alert', message , 'alert-warning');
          });          
      });
      // Shows the current strength level of the password 
      $(this).find('.check-strength').on('keyup', function () {
        checkStrength($('.check-strength').val())
      })  
    });

    // Toggles between showing and hiding password
    $(".show-hide-password-reset a").on('click', function (event) {
      event.preventDefault();
      // Toggles both new password and confirm password inputs as both have the new-confirm-password class
      $('.eye-password-reset').toggleClass('fa-eye-slash fa-eye');
      var $field = $('.show-hide-password-reset input')
      if ($field.attr('type') === 'password') {
        $field.attr('type', 'text');
      } else {
        $field.attr('type', 'password');
      }
    });
  }
  /**
   * HTTP FUNCTIONS
   */
  /**
   * Initate a Password Reset based on the Email/MydexID passed
   * @param {} data 
   * @returns 
   */
  function postResetPassword( data ) {
      
      var csrf = Util.getCSRF();
      return $.ajax({
        url: `/password/reset`,
        type: 'post',
        dataType: 'json',
        headers: {
          'x-csrf-token': csrf
        },
        data: data,
      });
  }
  /**
   * Change the password following a password reset request.  
   * @param {} data 
   * @returns 
   */
  function postPasswordChangeReset( data ) {
      
      var csrf = Util.getCSRF();
      return $.ajax({
        url: `/password/reset/confirm`,
        type: 'post',
        dataType: 'json',
        headers: {
          'x-csrf-token': csrf
        },
        data: data,
      });
  }
  /**
   * HELPER FUNCTIONS
   */
  /**
   * Validate the password reset form using the HTML Constraint API
   * @param {*} form 
   * @returns 
   */
  function validate( form ) {

    // Remove the was-validated class if it existed on the form.  This will clear the validatoin back to a blank slate
    $(form).removeClass('was-validated');

    // Get the data-id of the form - if not exist stop, we need the ID
    let id = form.getAttribute('data-id');
    if(!id) { throw Error(`No id supplied for password-change component ${id}`);}
       
    // Check there are values
    // Note it should be possible to induvidually check constraints 
    var  isValid = true;
    if (form.checkValidity() === false) {
      document.getElementById(`myds-password-reset-credentialinfo-${id}`).innerHTML = "This field is required";
      isValid = false;
    }
    $(form).toggleClass('was-validated');
    return isValid;
  }
  
  /**
   * Validate the password reset form using the HTML Constraint API
   * @param {*} form 
   * @returns 
   */
  function validatePasswordChangeReset( form ) {
    // Remove the was-validated class if it existed on the form.  This will clear the validatoin back to a blank slate
    $(form).removeClass('was-validated');

    // Get the data-id of the form - if not exist stop, we need the ID
    let id = form.getAttribute('data-id');
    if(!id) { throw Error(`No id supplied for password-change component ${id}`);}
    
    var newPassword = document.getElementById(`myds-password-change-reset-newpassword-${id}`);
    var confirmPassword = document.getElementById(`myds-password-change-reset-confirmpassword-${id}`);
    var newPasswordInfo = document.getElementById(`myds-password-change-reset-newpasswordinfo-${id}`);
    var confirmPasswordInfo = document.getElementById(`myds-password-change-reset-confirmpasswordinfo-${id}`);
   
    // Check there are values and the min lengh is > 8
    // Not it should be possible to induvidually check constraints 
    var  isValid = true;
    if (form.checkValidity() === false) {
      newPasswordInfo.innerHTML = "This field is required and must be greater than 8 characters";
      confirmPasswordInfo.innerHTML = "This field is required and must be greater than 8 characters";
      isValid = false;
    }
    
    // Check the new/confirmation match
    if ( newPassword.value != confirmPassword.value ) {
      // Set the styling and message for the error
      newPassword.classList.add('is-invalid');
      confirmPassword.classList.add('is-invalid');
      newPasswordInfo.innerHTML = "Passwords Don't Match";
      confirmPasswordInfo.innerHTML = "Passwords Don't Match";
      isValid = false;
    }
    $(form).toggleClass('was-validated');
    return isValid;

  }
  return {
    init: init
  }
}());

/**
 * Function to check the strengh of a input fields and 
 * progress a bootstrap progress bar
 * @param {*} password 
 */
function checkStrength (password){

    var strengthBar = $('#strength');
    var strengthLevel = $('#password-strength-level')
    var strength = 0;

    // Checks each character input and adds to password strength score
    if(password.match(/[a-zA-Z0-9][a-zA-Z0-9]+/)){
      strength += 1;
    }
    if (password.match(/[~<>?]+/)){
      strength += 1;
    }
    if (password.match(/[!@£$%^&*()]+/)){
      strength += 1;
    }
    if (password.length > 6){
      strength += 1;
    }
    if (password.length > 10){
      strength += 1;
    }

    // Resets the custom classes first and adds the strength level class to change the width of the progress bar
    switch (strength) {
      case 0:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-0');
        strengthLevel.text('');
        break;
      case 1:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-20');
        strengthLevel.text('Weak');
        break;
      case 2:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-40');
        strengthLevel.text('Fair');
        break;
      case 3:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-60');
        strengthLevel.text('Good');
        break;
      case 4:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-80');
        strengthLevel.text('Strong');
        break;
      case 5:
        strengthBar.removeClass();
        strengthBar.addClass('progress-bar strength-100');
        strengthLevel.text('Very Strong');
        break;
    }
}

